module.exports = __webpack_public_path__ + "static/media/mudey_rating5.81e78379.svg";